import React from "react";
import { Fade } from "react-awesome-reveal";
import moment from "moment";

import "./VerticalTimeline.css";

import ScrollDown from "../ScrollDown/ScrollDown";

const VerticalTimeline = ({ events, scrollToPortfolio }) => {
  const formatDate = (dateString) => {
    const today = moment().format("YYYY-MM-DD");
    return dateString === today
      ? "à ce jour"
      : moment(dateString).format("MMM YYYY");
  };

  return (
    <>
      <div className="timeline-container">
        {events
          .slice()
          .reverse()
          .map((event, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-date">
                {event.type === "date"
                  ? formatDate(event.date)
                  : `${formatDate(event.start)} - ${formatDate(event.end)}`}
              </div>
              <div className="timeline-content">
                <Fade direction="right" cascade triggerOnce damping={0.1}> 
                  <h3 className="timeline-title">{event.title}</h3>
                </Fade>
              </div>
            </div>
          ))}
      </div>
      <div className="scrollDown">
        <ScrollDown scrollDown={scrollToPortfolio} />
      </div>
    </>
  );
};

export default VerticalTimeline;
